import { render } from "./ImageMessage.vue?vue&type=template&id=4155112c&scoped=true"
import script from "./ImageMessage.vue?vue&type=script&lang=js"
export * from "./ImageMessage.vue?vue&type=script&lang=js"

import "./ImageMessage.vue?vue&type=style&index=0&id=4155112c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4155112c"]])

export default __exports__